import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../../core/design-system/components/Icon';
import { formatMonthYear } from '../../../../shared/utils/date/DateFormatters';
import './styles.css';

const ProfileStats = ({ user }) => {
  const { t } = useTranslation('profile');
  
  const formattedDate = formatMonthYear(user?.joinDate);

  return (
    <div className="profile-stats">
      <div className="follow-stats">
        <button className="stat-item">
          <span className="stat-value">{user?.following?.length || 0}</span>
          <span className="stat-label">{t('stats.following')}</span>
        </button>
        <button className="stat-item">
          <span className="stat-value">{user?.followers?.length || 0}</span>
          <span className="stat-label">{t('stats.followers')}</span>
        </button>
      </div>
      <div className="join-date">
        <Icon name="calendar" size={16} />
        <span>{t('stats.joined', { date: formattedDate })}</span>
      </div>
    </div>
  );
};

export default ProfileStats; 